import { useState, useEffect } from "react";
import { addRace, updateRace } from "../../services/raceService";
import "./race.css";

const initialState = {
  name: "",
  round: "",
  circuit_name: "",
  circuit_length_km: "",
  air_temp: "",
  track_temp: "",
  degradation_level: "MEDIUM",
  undercut_power: "MODERATE",
  overcut_power: "MODERATE",
  session: "Race",
  race_date: "",
  strategy_notes: ""
};

function RaceForm({ selectedRace, refresh, clearSelection }) {
  const [form, setForm] = useState(initialState);

  useEffect(() => {
    if (selectedRace) {
      setForm({
        ...selectedRace,
        race_date: selectedRace.race_date || ""
      });
    } else {
      setForm(initialState);
    }
  }, [selectedRace]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]:
        e.target.type === "number"
          ? Number(value)
          : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedData = {
      ...form,
      round: Number(form.round),
      circuit_length_km: Number(form.circuit_length_km),
      air_temp: Number(form.air_temp),
      track_temp: Number(form.track_temp),
      updated_at: new Date()
    };

    if (selectedRace?.id) {
      await updateRace(selectedRace.id, formattedData);
    } else {
      await addRace({
        ...formattedData,
        created_at: new Date()
      });
    }

    refresh();
    clearSelection();
    setForm(initialState);
  };

  return (
    <div className="race-container">
      <h2 className="race-title">
        {selectedRace ? "Edit Race" : "Create Race"}
      </h2>

{selectedRace && (
  <div style={{ marginBottom: "20px", color: "#e10600" }}>
    Editing: {selectedRace.name}
  </div>
)}
      <p className="race-subtitle">
        Manage race intelligence and strategic parameters
      </p>

      <form onSubmit={handleSubmit} className="race-form">

        {/* Row 1 */}
        <div className="row">
          <div className="field">
            <label>Race Name</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="field">
            <label>Round</label>
            <input
              type="number"
              name="round"
              value={form.round}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="row">
          <div className="field">
            <label>Circuit Name</label>
            <input
              name="circuit_name"
              value={form.circuit_name}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Circuit Length (km)</label>
            <input
              type="number"
              step="0.001"
              name="circuit_length_km"
              value={form.circuit_length_km}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="row">
          <div className="field">
            <label>Air Temp (°C)</label>
            <input
              type="number"
              name="air_temp"
              value={form.air_temp}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Track Temp (°C)</label>
            <input
              type="number"
              name="track_temp"
              value={form.track_temp}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 4 */}
        <div className="row">
          <div className="field">
            <label>Degradation Level</label>
            <select
              name="degradation_level"
              value={form.degradation_level}
              onChange={handleChange}
            >
              <option value="LOW">LOW</option>
              <option value="MEDIUM">MEDIUM</option>
              <option value="HIGH">HIGH</option>
            </select>
          </div>

          <div className="field">
            <label>Session</label>
            <select
              name="session"
              value={form.session}
              onChange={handleChange}
            >
              <option value="FP1">FP1</option>
              <option value="FP2">FP2</option>
              <option value="Qualifying">Qualifying</option>
              <option value="Race">Race</option>
            </select>
          </div>
        </div>

        {/* Row 5 */}
        <div className="row">
          <div className="field">
            <label>Undercut Power</label>
            <select
              name="undercut_power"
              value={form.undercut_power}
              onChange={handleChange}
            >
              <option value="WEAK">WEAK</option>
              <option value="MODERATE">MODERATE</option>
              <option value="STRONG">STRONG</option>
            </select>
          </div>

          <div className="field">
            <label>Overcut Power</label>
            <select
              name="overcut_power"
              value={form.overcut_power}
              onChange={handleChange}
            >
              <option value="WEAK">WEAK</option>
              <option value="MODERATE">MODERATE</option>
              <option value="STRONG">STRONG</option>
            </select>
          </div>
        </div>

        {/* Row 6 */}
        <div className="field">
          <label>Race Date</label>
          <input
            type="date"
            name="race_date"
            value={form.race_date}
            onChange={handleChange}
          />
        </div>

        {/* Row 7 */}
        <div className="field">
          <label>Strategy Notes</label>
          <textarea
            name="strategy_notes"
            value={form.strategy_notes}
            onChange={handleChange}
            rows="4"
          />
        </div>

        <div className="button-row">{selectedRace && (
  <button
    type="button"
    onClick={clearSelection}
    style={{
      marginRight: "10px",
      background: "#1f1f1f",
      border: "1px solid #333",
      padding: "10px 20px",
      borderRadius: "8px",
      color: "#aaa"
    }}
  >
    Cancel
  </button>
)} </div>
        <div className="button-row">
          <button type="submit" className="primary-btn">
            {selectedRace ? "Update Race" : "Publish Race"}
          </button>
        </div>

      </form>
    </div>
  );
}

export default RaceForm;